import React, { Component } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Header from '../../component/common/Header';

import { getMedicalListForDesk } from '../../actions/MasterAction';
import CONSTANT from '../../constant';
import { getCookie, getDateParts, getDatePartsfromTimestamp, getStorage } from '../../utils';
import EditModule from './EditMoule/EditModule';

 export default class MedicalDesk extends Component {
    constructor(props) {
        super(props);
         
        this.state = {
            userDetail : getCookie(CONSTANT.cookie.userDetail),
            hrDealing:getStorage(CONSTANT.cookie.hrDealingOfficerList)[0],   
            hrExecutive:getStorage(CONSTANT.cookie.hrexecutive)[0],
            finance:getStorage(CONSTANT.cookie.hrexecutive), 
            list: undefined,
            date: new Date()
        }

         
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allEtours;        
           
        getMedicalListForDesk().then((res) => {
                this.setState({list:res.result})
                res.result.filter((ele)=>  { return (ele.levelOne=='true' &&  ele.levelTwo=="false")} )  
            });

         } 

   openDetailPage =(pageUrl)=>{
    this.props.history.push(pageUrl)
 }



  render() {
      const {date ,list , userDetail} = this.state
    
     
      return (
        
         
        <div className="container-fluid">
        <div className="row">
            {/* <div className="col-md-2 px-0">
                <Header />
                 
            </div> */}
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-12 my-3">
                        <h1 className="page-title">Medical-Rimbursment {date.getFullYear()} </h1>
                    </div>
                </div>
                
                <div className="row mt-3">
                  {/*  <div className="col-md-3">
                        <Link to={CONSTANT.component.addMedicalClaim.url} className="btn btn-sm submit-button">
                            <i className="fa fa-plus-circle mr-2" />
                            Apply for Medical
                        </Link>
    </div> */}
                <div className="col-md-7"></div>
                     
                    <div className="col-md-2">

                    </div>
                </div>
                 

               {
                 
                userDetail.code==getStorage(CONSTANT.cookie.hrDealingOfficerList)[0].code? 
                <div className="row">
                <div className="col-md-12 mt-3">
                    <div className="list-container">
                    <h3 class="page-title">Requested Medicals  </h3>
                        <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                            <tbody>
                                <tr>
                                    <th scope="col" style={{ width: '3%' }}>#</th>
                                    <th scope="col ">Description</th>
                                    <th scope="col">Requested by</th>
                                    <th scope="col">Created on</th>
                                    <th scope="col">Status</th>

                                </tr>
                                 
                                     {list === undefined && <tr>
                                         <td colSpan={5} className="text-center">Loading...</td>
                                     </tr>    
                                  }
                                 
                                    {  list !== undefined && list.length === 0 && <tr>
                                     <td colSpan={5} className="text-center">No records found</td>
                                    </tr>}

                                {
                                    
                                    list !== undefined && list.map((item, index) => {
                                        const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                        const dated = getDatePartsfromTimestamp(item.createdOn) ; 
                                       if(item.levelOne=="false" && item.levelTwo=="false" ){
                                        return (
                                            <tr key={index} className="c-pointer" 
                                            onClick={() => this.openDetailPage(detailPageURL)}
                                             >
                                                <td>{index + 1}</td>
                                                <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                <td>{item.requestedby}</td>
                                                <td>{`${dated.date} ${dated.month} ${dated.year}`}</td>
                                                <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                </tr>
                                             ) 
                                       }
                                        
                                    })  
                                 }
                                

                                 
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> :""} 
             
            {            userDetail.code==getStorage(CONSTANT.cookie.hrDealingOfficerList)[0].code?
            <React.Fragment>
              
                 <div className="row">
            <div className="col-md-12 mt-3">
                <div className="list-container">
                <h3 class="page-title"> Approved Medicals  </h3>
                    <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                        <tbody>
                            <tr>
                                <th scope="col" style={{ width: '3%' }}>#</th>
                                <th scope="col ">Description</th>
                                <th scope="col">Requested by</th>
                                <th scope="col">Modified</th>
                                <th scope="col">Status</th>

                            </tr>
                             
                         
                                 {list === undefined && <tr>
                                     <td colSpan={5} className="text-center">Loading...</td>
                                 </tr>    
                              }
                             
                                {  list !== undefined && list.length === 0 && <tr>
                                 <td colSpan={5} className="text-center">No records found</td>
                                </tr>}

                            {
                                list !== undefined && list.length>0 &&  list.map((item, index) => {
                                    const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                    const dated = getDateParts(item.modifiedBy) ;
                                    
                                    
                                      if(item.levelOne=='true'  ){
                                        return (
                                         
                                            <tr key={index} className="c-pointer" 
                                            onClick={() => this.openDetailPage(detailPageURL)}
                                             >
                                                <td>{index + 1}</td>
                                                <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                <td>{item.requestedby}</td>
                                                <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                 {
                                                     userDetail.code==this.state.hrDealing.code?
                                                <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                  : userDetail.code==this.state.hrExecutive.code? 
                                                <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                     :""
                                                 }
                                            
                                                </tr>
                                        )
                                         
                                      }   
                                    
                                })  
                             }
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
            </React.Fragment>
            : ""
               }


                
                { 
                    userDetail.code==getStorage(CONSTANT.cookie.hrexecutive)[0].code   
                 ? 
                 <div className="row">
            <div className="col-md-12 mt-3">
                <div className="list-container">
                <h3 class="page-title"> Pending Medicals  </h3>
                    <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                        <tbody>
                            <tr>
                                <th scope="col" style={{ width: '3%' }}>#</th>
                                <th scope="col ">Description</th>
                                <th scope="col">Requested by</th>
                                <th scope="col">Modified</th>
                                <th scope="col">Status</th>

                            </tr>
                             
                                 {  list === undefined && <tr>
                                     <td colSpan={5} className="text-center">Loading...</td>
                                 </tr>    
                                 }
                             
                                { list !== undefined && list.length === 0 && <tr>
                                 <td colSpan={5} className="text-center">No records found</td>
                                </tr>}

                            {
                                list !== undefined && list.filter((ele)=>{return(ele.levelOne=="true" && ele.levelTwo=="false")}).map((item, index) => {
                                    const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                    const dated = getDateParts(item.modifiedBy) ;
                                    
                                    
                                    //   if(item.levelOne=='true' ){
                                        return (
                                         
                                            <tr key={index} className="c-pointer" 
                                            onClick={() => this.openDetailPage(detailPageURL)}
                                             >
                                                <td>{index + 1}</td>
                                                <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                <td>{item.requestedby}</td>
                                                <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                 {
                                                     userDetail.code==this.state.hrDealing.code?
                                                <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                  : userDetail.code==this.state.hrExecutive.code? 
                                                <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                     :""
                                                 }
                                            
                                                </tr>
                                        )
                                         
                                    //   }   
                                    
                                })  
                             }
                            
                        </tbody>
                    </table>
                </div>
            </div>
        </div>:""     
                            } 
                            
                            
                             
                             
                            { 
                    userDetail.code==getStorage(CONSTANT.cookie.hrexecutive)[0].code ? 
                 <div className="row">
                 <div className="col-md-12 mt-3">
                     <div className="list-container">
                     <h3 class="page-title"> Approved Medicals   </h3>
                         <table className="table table-bordered table-hover" style={{wordWrap:"break-word"}}>
                             <tbody>
                                 <tr>
                                     <th scope="col" style={{ width: '3%' }}>#</th>
                                     <th scope="col ">Description</th>
                                     <th scope="col">Requested by</th>
                                     <th scope="col">Modified</th>
                                     <th scope="col">Status</th>
     
                                 </tr>
                                  
                                      {  list === undefined && <tr>
                                          <td colSpan={5} className="text-center">Loading...</td>
                                      </tr>    
                                      }
                                  
                                     { list !== undefined && list.length === 0 && <tr>
                                      <td colSpan={5} className="text-center">No records found</td>
                                     </tr>}
     
                                 {
                                     list !== undefined && list.map((item, index) => {
                                         const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                         const dated = getDateParts(item.modifiedBy) ;
                                         
                                         
                                           if(item.levelOne=='true' && item.levelTwo=='true'  ){
                                             return (
                                              
                                                 <tr key={index} className="c-pointer" 
                                                 onClick={() => this.openDetailPage(detailPageURL)}
                                                  >
                                                     <td>{index + 1}</td>
                                                     <td className="text-truncate" style={{maxWidth:"50px"}} >{item.description}</td>
                                                     <td>{item.requestedby}</td>
                                                     <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                      {
                                                          userDetail.code==this.state.hrDealing.code?
                                                     <td>{item.levelOne=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                       : userDetail.code==this.state.hrExecutive.code? 
                                                     <td>{item.levelTwo=="false"?<span class="badge badge-warning w-50 p-1 " >Pending </span>  : <span class="badge badge-success w-50 p-1 ">Approved</span>   }</td>
                                                          :""
                                                      }
                                                 
                                                     </tr>
                                             )
                                              
                                           }   
                                         
                                     })  
                                  }
                                 
                             </tbody>
                         </table>
                     </div>
                 </div>
             </div>  :" "



                    
                }



                 


                 {
                    <EditModule   />
                 }

               
                 
               



                <div className="row">
                    <div className="col-md-3">
                        <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control">Year {date.getFullYear() - 1}</button>
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-3">
                        <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control">Year {date.getFullYear() + 1}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
  }
}
